// Adresse de contact client unique (l'ancienne boîte du domaine n'est pas encore opérationnelle en réception : ne pas l'utiliser).
export const CONTACT_EMAIL = "contact.patripilot@gmail.com";
export const CONTACT_MAILTO = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent("SanitDocs — demande d'abonnement / contact")}`;
